import EDORepository from "./../api/index"
import "../types"

class EDOUseCase {
    constructor() {
        /** @type {EDORepository}*/
        this.api = new EDORepository()
    }

    /**
     *
     *  @param param {string}
     * @return {Promise<{data: EDOS, err: null}|{data: null, err: ErrorState}>}
     */
    async getAll(param) {
        const {data, err} = await this.api.getAll(param)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }
}

export default new EDOUseCase()
